import { useEffect, useState } from 'react';
import { APP_IMAGES, AppConfig } from '../constants';
import { useIsMobileView } from './useIsMobileView';

export const useAppImages = (merchantName: string) => {
  const isMobile = useIsMobileView();
  const [spinner, setSpinnerSrc] = useState('');
  const [logo, setLogoSrc] = useState('');
  const [splashLogo, setSplashLogoSrc] = useState('');
  const [card, setCardSrc] = useState('');
  const [background, setBackgroundSrc] = useState('');

  useEffect(() => {
    const getBaseUrl = () => {
      if (merchantName) {
        return `${AppConfig.CDN_BASE_URL}/${merchantName}`;
      }
      return `${AppConfig.CDN_BASE_URL}/${AppConfig.PARTNER}/${AppConfig.DEFAULT_MERCHANT_NAME}`;
    };

    const baseUrl = getBaseUrl();
    const backgroundImg = isMobile ? APP_IMAGES.bannerXs : APP_IMAGES.bannerLg;
    const cardImg = isMobile ? APP_IMAGES.cardXs : APP_IMAGES.cardLg;

    setBackgroundSrc(`${baseUrl}/${backgroundImg}.png`);
    setCardSrc(`${baseUrl}/${cardImg}.png`);
    setLogoSrc(`${baseUrl}/${AppConfig.LOGO_IMAGE_NAME}`);
    setSplashLogoSrc(`${baseUrl}/${AppConfig.SPLASH_LOGO_IMAGE_NAME}`);
    setSpinnerSrc(`${baseUrl}/${APP_IMAGES.spinner}.gif`);
  }, [isMobile, merchantName]);

  return { logo, background, card, spinner, splashLogo };
};
